// Single source of truth for activity constants
// These values come from the Ruby Place model via window.MPF_ACTIVITIES

// Get activities from Ruby object or use defaults for backwards compatibility
const MPF = window.MPF_ACTIVITIES || {
  UNDERTAKER: 'undertaker',
  MARBLE: 'marble',
  CREMATORIUM: 'crematorium',
  FUNERARIUM: 'funerarium',
  CEMETERY: 'cemetery',
};

// Named constants for readable access
export const { UNDERTAKER } = MPF;
export const { MARBLE } = MPF;
export const { CREMATORIUM } = MPF;
export const { FUNERARIUM } = MPF;
export const { CEMETERY } = MPF;

// Export the array for iteration
export const ACTIVITIES = [
  UNDERTAKER,
  MARBLE,
  CREMATORIUM,
  FUNERARIUM,
  CEMETERY,
];

// Validation helper
export function validateActivity(activity) {
  return ACTIVITIES.includes(activity) ? activity : UNDERTAKER;
}

export function cityPath(departmentCode, citySlug) {
  return `/${departmentCode.toLowerCase()}/${citySlug}`;
}
